// extracted by mini-css-extract-plugin
module.exports = {"component":"secondary-header-item_component__gerbF","image":"secondary-header-item_image__lXO2P","videoIcon":"secondary-header-item_videoIcon__QpJQt"};